import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCBPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-4512">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-4513">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-4514">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-4515">
              <XIcon className="w-6 h-6" data-id="element-4516" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-4517">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-meta_cmp-mcc_pt-optin" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-4518"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-4519">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-4520">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-4521" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-4522">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-4523">
        <div className="flex justify-center md:justify-between items-center" data-id="element-4524">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-4525" />
          <div className="hidden md:block" data-id="element-4526">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-4527">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-4528">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-4529">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-4530">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-4531">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-4532">
        <div className="md:col-span-7" data-id="element-4533">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4 text-center md:text-left" data-id="element-4534">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-3xl md:text-5xl font-extrabold text-[#1a2b4a] mb-6 leading-tight text-center md:text-left" data-id="element-4535">
            Stop Het Blaffen, Trekken en Uitvallen - Zonder Straffen
          </h1>
          <div className="md:hidden mb-6" data-id="element-4536">
            <img src="https://cdn.magicpatterns.com/uploads/qnzT9c8MEjsZMbSpGR8q95/MCC_webinar_preview.png" alt="Webinar preview: Communiceren met je Hond" className="w-full rounded-2xl shadow-lg" data-id="element-4537" />
          </div>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-4538">
            Ja, ik wil dit oplossen →
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-4539">
            <div className="flex -space-x-3" data-id="element-4540">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4541" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4542" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-4543" />
            </div>
            <div data-id="element-4544">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-4545">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-4546">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-4547">
            Ontdek in dit gratis 90-minuten webinar de liefdevolle aanpak
            waarmee duizenden baasjes probleemgedrag hebben opgelost
          </p>

          <ul className="space-y-4 mb-8" data-id="element-4548">
            {['Waarom je hond blaft, trekt of uitvalt - en wat hij je écht probeert te vertellen', 'De signalen die je nu mist - waardoor probleemgedrag blijft terugkomen', 'Hoe je angst, stress en onzekerheid herkent - voordat het escaleert', 'Waarom straffen en corrigeren het probleem erger maakt - en wat wél werkt', 'Hoe wandelen weer ontspannen wordt - zonder dat je andere honden moet ontwijken', 'Concrete stappen om vandaag nog te starten met een nieuwe aanpak'].map((item, i) => <li key={i} className="flex items-start" data-id="element-4549">
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-4550" />
                <span className="text-gray-700 font-medium" data-id="element-4551">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-4552">
            <div className="flex -space-x-3" data-id="element-4553">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4554" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4555" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-4556" />
            </div>
            <div data-id="element-4557">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-4558">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-4559">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-4560">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-4561">
            <div className="flex justify-center items-center w-full" data-id="element-4562">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-4563"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-4564">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4565">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-4566">
            Los probleemgedrag op in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-4567">
            <div className="flex flex-col items-center" data-id="element-4568">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4569" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4570">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-4571">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4572">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-4573" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4574">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-4575">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-4576">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-4577" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-4578">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-4579">
                Leer in 90 minuten de aanpak die probleemgedrag écht oplost
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4580">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-4581">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-4582">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-4583">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-4584" />
            <span className="italic" data-id="element-4585">
              "Wandelen is weer een genot. Eindelijk rust."
            </span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-4586">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4587">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4588">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-4589"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4590">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4591">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-4592"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-4593">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-4594">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-4595"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-4596">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4597">
              <div className="flex items-center mb-4" data-id="element-4598">
                <div className="flex text-green-500 mr-2" data-id="element-4599">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4600" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4601">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4602">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4603">
                In korte tijd zoveel geleerd en handvatten gekregen. We hebben
                herplaatsers, dus we zijn wel wat gewend. Maar nu hebben we
                eindelijk de tools.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4604">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4605">
              <div className="flex items-center mb-4" data-id="element-4606">
                <div className="flex text-green-500 mr-2" data-id="element-4607">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4608" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4609">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4610">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4611">
                De tips helpen echt. Ik raad iedereen met hondjes en problemen
                deze cursus aan. Volg de gratis Masterclass en je bent
                overtuigd.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4612">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4613">
              <div className="flex items-center mb-4" data-id="element-4614">
                <div className="flex text-green-500 mr-2" data-id="element-4615">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4616" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4617">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4618">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4619">
                Vooral met onbekende honden was er toch vaak wel flink geblaf.
                Nu bijna niet meer. Heerlijk, wat is wandelen toch weer een
                genot. Inderdaad: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4620">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-4621">
              <div className="flex items-center mb-4" data-id="element-4622">
                <div className="flex text-green-500 mr-2" data-id="element-4623">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-4624" />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-4625">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-4626">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-4627">
                Voorbereid zijn op de puppy die ik krijg en weten hoe ik
                problemen voorkom. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-4628">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-4629">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-4630">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-4631">
          <div data-id="element-4632">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-4633">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-4634">
              <p data-id="element-4635">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies weet hoe frustrerend het is als je hond gedrag vertoont
                dat je maar niet opgelost krijgt.
              </p>
              <p data-id="element-4636">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes mogen
                helpen bij het oplossen van probleemgedrag. Van blaffen tot
                trekken, van uitvallen tot angst. En wat ik keer op keer zie: de
                meeste problemen zijn geen trainingsproblemen. Het zijn
                communicatieproblemen.
              </p>
              <p data-id="element-4637">
                De frustratie komt niet door een 'slechte' hond of een 'falende'
                baas. Het komt doordat baasjes en honden letterlijk twee
                verschillende talen spreken. Zodra je leert communiceren in de
                taal van je hond, verdwijnen de problemen. De strijd maakt
                plaats voor samenwerking.
              </p>
              <p data-id="element-4638">
                Daarom werk ik uitsluitend met methodes gebaseerd op vertrouwen,
                veiligheid en echte communicatie. Geen dwang, geen straf. Alleen
                liefde en begrip.
              </p>
              <p data-id="element-4639">
                Dit webinar is mijn manier om deze aanpak met zoveel mogelijk
                baasjes te delen. Omdat ik geloof dat elk probleem oplosbaar is
                - als je maar weet hoe.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-4640">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-4641" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-4642">
        <div className="max-w-md mx-auto px-4" data-id="element-4643">
          <div className="p-6 rounded-3xl w-full" data-id="element-4644">
            <div className="flex justify-center items-center" data-id="element-4645">
              <iframe src="https://app.webinargeek.com/embed/7dfdb212-bc5c-456b-9231-b35ea1f59a5c?cst=src-meta_cmp-mcc_pt-optin" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-4646"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-4647">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-4648">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-4649" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-4650">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-4651">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-4652">
            <p className="mb-2" data-id="element-4653">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-4654">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-4655" />
    </div>;
}